import { Link, Outlet, useRouterState } from "@tanstack/react-router";
import { PwaAffordances } from "./PwaAffordances";

export function Layout() {
  const { location } = useRouterState();
  const path = location.pathname;

  return (
    <div className="min-h-screen bg-ink text-slate-100">
      <PwaAffordances />
      <header
        className="border-b border-slate-800 bg-slate-900/60 backdrop-blur sticky top-0 z-10"
        style={{ paddingTop: "env(safe-area-inset-top)" }}
      >
        <div className="mx-auto max-w-5xl px-4 py-3 flex items-center gap-4">
          <Link to="/" className="text-lg font-semibold shrink-0">
            Money
          </Link>
          <nav className="flex gap-4 text-sm overflow-x-auto whitespace-nowrap">
            <NavLink to="/" active={path === "/"}>
              Dashboard
            </NavLink>
            <NavLink to="/transactions" active={path === "/transactions"}>
              Transactions
            </NavLink>
            <NavLink to="/review" active={path === "/review"}>
              Review
            </NavLink>
            <NavLink to="/patterns" active={path === "/patterns"}>
              Patterns
            </NavLink>
            <NavLink to="/fire" active={path === "/fire"}>
              FIRE
            </NavLink>
            <NavLink to="/investments" active={path === "/investments"}>
              Investments
            </NavLink>
            <NavLink to="/digest" active={path === "/digest"}>
              Digest
            </NavLink>
            <NavLink to="/settings" active={path === "/settings"}>
              Settings
            </NavLink>
          </nav>
        </div>
      </header>
      <main className="mx-auto max-w-5xl px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}

function NavLink({
  to,
  active,
  children,
}: {
  to: string;
  active: boolean;
  children: React.ReactNode;
}) {
  return (
    <Link
      to={to}
      className={
        active
          ? "text-slate-100 font-medium"
          : "text-slate-400 hover:text-slate-200"
      }
    >
      {children}
    </Link>
  );
}
